import { language } from 'curvy';

export const english: language.TranslationDefinition = {
	locale: 'en-us',
	translations: {
		"ADD_NEW_INSURER": "Add new insurer",
		"COMPANY_SETTINGS": "Company settings",
		"COMPANY_SETTINGS.INSURERS": "Insurers",
		"COMPANY_SETTINGS.DELETE_INSURER.TITLE": "Delete insurer",
		"COMPANY_SETTINGS.DELETE_INSURER.MSG": (insurer) => `Are you sure you want to delete ${insurer}?`,
		
    }
};

export const croatian: language.TranslationDefinition = {
	locale: 'hr-hr',
	translations: {
		
		"ADD_NEW_INSURER": "Dodaj osiguravajuću kuću",
		"COMPANY_SETTINGS": "Postavke tvrtke",
		"COMPANY_SETTINGS.INSURERS": "Osiguravajuće kuće",
		"COMPANY_SETTINGS.DELETE_INSURER.TITLE": "Izbriši osiguravajuću kuću",
		"COMPANY_SETTINGS.DELETE_INSURER.MSG": (insurer) => `Jeste li sigurni da želite izbrisati ${insurer}?`,
	}

};

export const company_settings_translations = [english, croatian];
